// import React, { useEffect, useState } from "react";
// import { Box, Button, Modal, IconButton, Typography, Fade, Slide, Grow } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import NewspaperIcon from "@mui/icons-material/Newspaper";
// import TrendingUpIcon from "@mui/icons-material/TrendingUp";
// import OpenInNewIcon from "@mui/icons-material/OpenInNew";
// import axios from "axios";
// import Marquee from "react-fast-marquee";
// import { useTranslation } from "react-i18next";
// import { API_BASE_URL } from "../../config";
// import { LoadingSpinner } from "../../Components/spinner/spinner";
// import { SnackBarComponent } from "../../Components/snackBar/snackBar";

// const modalStyle = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: { xs: "90vw", sm: "80vw", md: "70vw" },
//   maxWidth: 600,
//   maxHeight: "85vh",
//   bgcolor: "#f7fafd",
//   boxShadow: "0 20px 60px rgba(0,0,0,0.15), 0 8px 32px rgba(0,0,0,0.1)",
//   p: { xs: 2, sm: 3 },
//   overflow: "hidden",
//   borderRadius: 4,
//   transition: "all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
//   '&:hover': {
//     boxShadow: "0 25px 80px rgba(0,0,0,0.2), 0 12px 40px rgba(0,0,0,0.15)",
//   }
// };

// export const News = () => {
//   const { t } = useTranslation();
//   const [news, setNews] = useState([]);
//   const [modalOpen, setModalOpen] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [hoveredIndex, setHoveredIndex] = useState(null);

//   // Snackbar States
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [snackbarSeverity, setSnackbarSeverity] = useState("info");

//   useEffect(() => {
//     const fetchNews = async () => {
//       setLoading(true);
//       try {
//         const response = await axios.get(`${API_BASE_URL}/home-notification/news/`);
//         setNews(response.data);
//       } catch (error) {
//         console.error("Error fetching news:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchNews();
//   }, []);

//   const handleSnackbarClose = () => {
//     setSnackbarOpen(false);
//   };

//   if (loading) {
//     return (
//       <Box
//         sx={{
//           height: { xs: "60px", sm: "70px", md: "80px" },
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           bgcolor: "#f5f5f5",
//           borderRadius: 1,
//           overflow: "hidden",
//           mt: 2,
//           boxShadow: 1,
//         }}
//       >
//         <LoadingSpinner size={28} color="primary" />
//       </Box>
//     );
//   }

//   return (
//     <>
//       <Slide direction="down" in={!loading} timeout={600}>
//         <Box
//           sx={{
//             height: { xs: "60px", sm: "70px", md: "80px" },
//             display: "flex",
//             alignItems: "center",
//             bgcolor: "#f5f5f5",
//             borderRadius: 1,
//             overflow: "hidden",
//             mt: 2,
//             boxShadow: 1,
//             position: "relative",
//             transition: "all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
//             '&:hover': {
//               transform: 'translateY(-2px)',
//               boxShadow: 3,
//             }
//           }}
//         >
//           {/* Left Red Button */}
//           <Fade in={!loading} timeout={800}>
//             <Button
//               variant="contained"
//               startIcon={<NewspaperIcon />}
//               sx={{
//                 position: "relative",
//                 height: "100%",
//                 minWidth: { xs: "100px", sm: "120px", md: "140px" },
//                 borderRadius: 0,
//                 fontWeight: "bold",
//                 fontSize: { xs: "0.7rem", sm: "0.8rem", md: "0.9rem" },
//                 textTransform: "none",
//                 whiteSpace: "nowrap",
//                 flex: "none",
//                 bgcolor: "red",
//                 transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
//                 overflow: "hidden",
//                 '&:hover': { 
//                   bgcolor: "#cc0000",
//                   transform: "scale(1.02)",
//                 },
//                 '&::before': {
//                   content: '""',
//                   position: 'absolute',
//                   top: 0,
//                   left: '-100%',
//                   width: '100%',
//                   height: '100%',
//                   background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
//                   transition: 'left 0.5s ease',
//                 },
//                 '&:hover::before': {
//                   left: '100%',
//                 }
//               }}
//             >
//               {t("latestNews")}
              
//               {/* Ribbon Corner - Same as original */}
//               <Box
//                 sx={{
//                   position: "absolute",
//                   top: 0,
//                   left: 0,
//                   width: 0,
//                   height: 0,
//                   borderTop: {
//                     xs: "15px solid #ffcc00",
//                     sm: "20px solid #ffcc00",
//                     md: "30px solid #ffcc00",
//                   },
//                   borderRight: {
//                     xs: "15px solid transparent",
//                     sm: "20px solid transparent",
//                     md: "30px solid transparent",
//                   },
//                   zIndex: 10,
//                   pointerEvents: "none",
//                 }}
//               />
//               <Box
//                 sx={{
//                   position: "absolute",
//                   top: { xs: 1, sm: 1.5, md: 2 },
//                   left: { xs: 1, sm: 1.5, md: 2 },
//                   fontSize: { xs: "0.5rem", sm: "0.65rem", md: "0.75rem" },
//                   fontWeight: "bold",
//                   color: "#8b6b00",
//                   userSelect: "none",
//                   pointerEvents: "none",
//                   transform: "rotate(-45deg)",
//                   width: { xs: "30px", sm: "40px", md: "60px" },
//                   textAlign: "center",
//                   fontFamily: "Arial, sans-serif",
//                 }}
//               >
//                 🎁
//               </Box>
//             </Button>
//           </Fade>

//           {/* Marquee Section */}
//           <Box
//             sx={{
//               flexGrow: 1,
//               overflow: "hidden",
//               px: { xs: 1, sm: 2 },
//               cursor: "pointer",
//               color: "red",
//               fontWeight: "500",
//               fontSize: { xs: "0.7rem", sm: "0.85rem", md: "1rem" },
//               display: "flex",
//               alignItems: "center",
//               height: "100%",
//             }}
//             aria-label={t("latestNewsScrolling")}
//           >
//             {news?.length === 0 ? (
//               <Fade in={!loading} timeout={800}>
//                 <Typography
//                   variant="body1"
//                   sx={{ 
//                     fontSize: { xs: "0.7rem", sm: "0.85rem" },
//                     color: "text.secondary",
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: 1
//                   }}
//                 >
//                   <TrendingUpIcon fontSize="small" />
//                   No News Available!
//                 </Typography>
//               </Fade>
//             ) : (
//               <Marquee 
//                 gradient={false} 
//                 speed={40} 
//                 pauseOnHover
//               >
//                 {news.map((item, index) => (
//                   <Box
//                     key={index}
//                     component="span"
//                     onClick={() => window.open(item.link, "_blank")}
//                     onMouseEnter={() => setHoveredIndex(index)}
//                     onMouseLeave={() => setHoveredIndex(null)}
//                     sx={{
//                       marginRight: "3rem",
//                       cursor: "pointer",
//                       color: "red",
//                       textDecoration: "none",
//                       whiteSpace: "nowrap",
//                       padding: "4px 12px",
//                       borderRadius: "20px",
//                       background: hoveredIndex === index ? "rgba(255,0,0,0.1)" : "transparent",
//                       transition: "all 0.3s ease",
//                       border: hoveredIndex === index ? "1px solid rgba(255,0,0,0.3)" : "1px solid transparent",
//                       display: "inline-flex",
//                       alignItems: "center",
//                       gap: 1,
//                       transform: hoveredIndex === index ? "scale(1.05)" : "scale(1)",
//                       boxShadow: hoveredIndex === index ? "0 4px 12px rgba(255,0,0,0.1)" : "none",
//                     }}
//                     title={item.subject}
//                   >
//                     <Box
//                       sx={{
//                         width: 6,
//                         height: 6,
//                         borderRadius: '50%',
//                         bgcolor: 'red',
//                         animation: 'pulse 2s infinite',
//                       }}
//                     />
//                     {item.subject}
//                   </Box>
//                 ))}
//               </Marquee>
//             )}
//           </Box>

//           {/* Right Red Button */}
//           <Fade in={!loading} timeout={800}>
//             <Button
//               variant="contained"
//               endIcon={<OpenInNewIcon />}
//               sx={{
//                 height: "100%",
//                 minWidth: { xs: "100px", sm: "120px", md: "140px" },
//                 borderRadius: 0,
//                 fontWeight: "bold",
//                 fontSize: { xs: "0.7rem", sm: "0.8rem", md: "0.9rem" },
//                 textTransform: "none",
//                 flex: "none",
//                 bgcolor: "red",
//                 transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
//                 overflow: "hidden",
//                 '&:hover': { 
//                   bgcolor: "#cc0000",
//                   transform: "scale(1.02)",
//                 },
//                 '&::before': {
//                   content: '""',
//                   position: 'absolute',
//                   top: 0,
//                   left: '-100%',
//                   width: '100%',
//                   height: '100%',
//                   background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
//                   transition: 'left 0.5s ease',
//                 },
//                 '&:hover::before': {
//                   left: '100%',
//                 }
//               }}
//               onClick={() => setModalOpen(true)}
//             >
//               {t("readMore")}
//             </Button>
//           </Fade>
//         </Box>
//       </Slide>

//       {/* Modal */}
//       <Modal 
//         open={modalOpen} 
//         onClose={() => setModalOpen(false)}
//         closeAfterTransition
//       >
//         <Fade in={modalOpen} timeout={400}>
//           <Box sx={modalStyle}>
//             {/* Modal Header */}
//             <Box
//               sx={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 position: "relative",
//                 mb: 3,
//                 bgcolor: "primary.main",
//                 borderRadius: 3,
//                 py: 2,
//                 px: 3,
//                 boxShadow: "0 2px 12px 0 rgba(60,60,120,0.10)",
//                 color: "#fff",
//               }}
//             >
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
//                 <NewspaperIcon sx={{ fontSize: '1.5rem' }} />
//                 <Typography
//                   variant="h6"
//                   component="h2"
//                   sx={{
//                     fontSize: { xs: "1.1rem", sm: "1.3rem" },
//                     fontWeight: "bold",
//                   }}
//                 >
//                   {t("allNewsNotifications")}
//                 </Typography>
//               </Box>
//               <IconButton
//                 onClick={() => setModalOpen(false)}
//                 aria-label={t("closeModal")}
//                 sx={{
//                   color: "#fff",
//                   background: "rgba(0,0,0,0.10)",
//                   transition: "all 0.3s ease",
//                   '&:hover': { 
//                     background: "rgba(0,0,0,0.18)",
//                     transform: "scale(1.1)",
//                   },
//                 }}
//               >
//                 <CloseIcon />
//               </IconButton>
//             </Box>

//             {/* News List */}
//             <Box sx={{ maxHeight: '60vh', overflowY: 'auto', pr: 1 }}>
//               {news?.length === 0 ? (
//                 <Box sx={{ textAlign: 'center', py: 4 }}>
//                   <TrendingUpIcon sx={{ fontSize: 48, color: 'text.secondary', mb: 2, opacity: 0.5 }} />
//                   <Typography sx={{ fontSize: { xs: "0.9rem", sm: "1rem" }, color: 'text.secondary' }}>
//                     {t("noNewsAvailable")}
//                   </Typography>
//                 </Box>
//               ) : (
//                 news.map((item, index) => (
//                   <Grow in={true} timeout={500 + (index * 100)} key={index}>
//                     <Box
//                       sx={{
//                         mb: 2,
//                         p: 2,
//                         borderBottom: "1px solid #ddd",
//                         cursor: "pointer",
//                         borderRadius: 2,
//                         transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
//                         boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
//                         position: "relative",
//                         overflow: "hidden",
//                         '&:hover': { 
//                           bgcolor: "#e3f2fd",
//                           transform: "translateY(-2px)",
//                           boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
//                         },
//                         '&::before': {
//                           content: '""',
//                           position: 'absolute',
//                           left: 0,
//                           top: 0,
//                           height: '100%',
//                           width: '4px',
//                           bgcolor: 'red',
//                           opacity: 0,
//                           transition: 'opacity 0.3s ease',
//                         },
//                         '&:hover::before': {
//                           opacity: 1,
//                         }
//                       }}
//                       onClick={() => window.open(item.link, "_blank")}
//                       onMouseEnter={() => setHoveredIndex(index)}
//                       onMouseLeave={() => setHoveredIndex(null)}
//                     >
//                       <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
//                         <Box
//                           sx={{
//                             width: 8,
//                             height: 8,
//                             borderRadius: '50%',
//                             bgcolor: 'red',
//                             mt: 1,
//                             flexShrink: 0,
//                             animation: 'pulse 2s infinite',
//                           }}
//                         />
//                         <Box sx={{ flex: 1 }}>
//                           <Typography
//                             variant="subtitle1"
//                             fontWeight="bold"
//                             sx={{ 
//                               fontSize: { xs: "0.9rem", sm: "1.1rem" },
//                               color: hoveredIndex === index ? "red" : "text.primary",
//                               transition: 'color 0.3s ease',
//                               mb: 0.5,
//                             }}
//                           >
//                             {item.subject}
//                           </Typography>
//                           {item.description && (
//                             <Typography
//                               variant="body2"
//                               color="textSecondary"
//                               sx={{ 
//                                 fontSize: { xs: "0.75rem", sm: "0.85rem" },
//                                 lineHeight: 1.4,
//                               }}
//                             >
//                               {item.description}
//                             </Typography>
//                           )}
//                         </Box>
//                         <OpenInNewIcon 
//                           sx={{ 
//                             fontSize: '1rem', 
//                             color: 'red',
//                             opacity: hoveredIndex === index ? 1 : 0,
//                             transition: 'all 0.3s ease',
//                             transform: hoveredIndex === index ? 'translateX(0)' : 'translateX(-10px)',
//                           }} 
//                         />
//                       </Box>
//                     </Box>
//                   </Grow>
//                 ))
//               )}
//             </Box>
//           </Box>
//         </Fade>
//       </Modal>

//       {/* Global styles for animations */}
//       <style jsx global>{`
//         @keyframes pulse {
//           0%, 100% { opacity: 1; transform: scale(1); }
//           50% { opacity: 0.7; transform: scale(1.1); }
//         }
//       `}</style>

//       {/* Snackbar */}
//       <SnackBarComponent
//         open={snackbarOpen}
//         message={snackbarMessage}
//         severity={snackbarSeverity}
//         onClose={handleSnackbarClose}
//       />
//     </>
//   );
// };


import React, { useEffect, useState } from "react";
import { Box, Button, Modal, IconButton, Typography, Fade, Slide, Grow } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import axios from "axios";
import Marquee from "react-fast-marquee";
import { useTranslation } from "react-i18next";
import { API_BASE_URL } from "../../config";
import { LoadingSpinner } from "../../Components/spinner/spinner";
import { SnackBarComponent } from "../../Components/snackBar/snackBar";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "90vw", sm: "80vw", md: "70vw" },
  maxWidth: 600,
  maxHeight: "85vh",
  bgcolor: "#f7fafd",
  boxShadow: "0 20px 60px rgba(0,0,0,0.15), 0 8px 32px rgba(0,0,0,0.1)",
  p: { xs: 2, sm: 3 },
  overflow: "hidden",
  borderRadius: 4,
  transition: "all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
  '&:hover': {
    boxShadow: "0 25px 80px rgba(0,0,0,0.2), 0 12px 40px rgba(0,0,0,0.15)",
  }
};

export const News = () => {
  const { t, i18n } = useTranslation();
  const [news, setNews] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  // Snackbar States
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("info");

  useEffect(() => {
    const fetchNews = async () => {
      setLoading(true);
      try {
        // Pass current language as query parameter
        const response = await axios.get(
          `${API_BASE_URL}/home-notification/news/`, 
          {
            params: { 
              language: i18n.language 
            }
          }
        );
        setNews(response.data);
      } catch (error) {
        console.error("Error fetching news:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, [i18n.language]); // Refetch when language changes

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  if (loading) {
    return (
      <Box
        sx={{
          height: { xs: "60px", sm: "70px", md: "80px" },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "#f5f5f5",
          borderRadius: 1,
          overflow: "hidden",
          mt: 2,
          boxShadow: 1,
        }}
      >
        <LoadingSpinner size={28} color="primary" />
      </Box>
    );
  }

  return (
    <>
      <Slide direction="down" in={!loading} timeout={600}>
        <Box
          sx={{
            height: { xs: "60px", sm: "70px", md: "80px" },
            display: "flex",
            alignItems: "center",
            bgcolor: "#f5f5f5",
            borderRadius: 1,
            overflow: "hidden",
            mt: 2,
            boxShadow: 1,
            position: "relative",
            transition: "all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
            '&:hover': {
              transform: 'translateY(-2px)',
              boxShadow: 3,
            }
          }}
        >
          {/* Left Red Button */}
          <Fade in={!loading} timeout={800}>
            <Button
              variant="contained"
              startIcon={<NewspaperIcon />}
              sx={{
                position: "relative",
                height: "100%",
                minWidth: { xs: "100px", sm: "120px", md: "140px" },
                borderRadius: 0,
                fontWeight: "bold",
                fontSize: { xs: "0.7rem", sm: "0.8rem", md: "0.9rem" },
                textTransform: "none",
                whiteSpace: "nowrap",
                flex: "none",
                bgcolor: "red",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                overflow: "hidden",
                '&:hover': { 
                  bgcolor: "#cc0000",
                  transform: "scale(1.02)",
                },
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: '-100%',
                  width: '100%',
                  height: '100%',
                  background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
                  transition: 'left 0.5s ease',
                },
                '&:hover::before': {
                  left: '100%',
                }
              }}
            >
              {t("latestNews")}
              
              {/* Ribbon Corner - Same as original */}
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: 0,
                  height: 0,
                  borderTop: {
                    xs: "15px solid #ffcc00",
                    sm: "20px solid #ffcc00",
                    md: "30px solid #ffcc00",
                  },
                  borderRight: {
                    xs: "15px solid transparent",
                    sm: "20px solid transparent",
                    md: "30px solid transparent",
                  },
                  zIndex: 10,
                  pointerEvents: "none",
                }}
              />
              <Box
                sx={{
                  position: "absolute",
                  top: { xs: 1, sm: 1.5, md: 2 },
                  left: { xs: 1, sm: 1.5, md: 2 },
                  fontSize: { xs: "0.5rem", sm: "0.65rem", md: "0.75rem" },
                  fontWeight: "bold",
                  color: "#8b6b00",
                  userSelect: "none",
                  pointerEvents: "none",
                  transform: "rotate(-45deg)",
                  width: { xs: "30px", sm: "40px", md: "60px" },
                  textAlign: "center",
                  fontFamily: "Arial, sans-serif",
                }}
              >
                🎁
              </Box>
            </Button>
          </Fade>

          {/* Marquee Section */}
          <Box
            sx={{
              flexGrow: 1,
              overflow: "hidden",
              px: { xs: 1, sm: 2 },
              cursor: "pointer",
              color: "red",
              fontWeight: "500",
              fontSize: { xs: "0.7rem", sm: "0.85rem", md: "1rem" },
              display: "flex",
              alignItems: "center",
              height: "100%",
            }}
            aria-label={t("latestNewsScrolling")}
          >
            {news?.length === 0 ? (
              <Fade in={!loading} timeout={800}>
                <Typography
                  variant="body1"
                  sx={{ 
                    fontSize: { xs: "0.7rem", sm: "0.85rem" },
                    color: "text.secondary",
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1
                  }}
                >
                  <TrendingUpIcon fontSize="small" />
                  No News Available!
                </Typography>
              </Fade>
            ) : (
              <Marquee 
                gradient={false} 
                speed={40} 
                pauseOnHover
              >
                {news.map((item, index) => (
                  <Box
                    key={index}
                    component="span"
                    onClick={() => window.open(item.link, "_blank")}
                    onMouseEnter={() => setHoveredIndex(index)}
                    onMouseLeave={() => setHoveredIndex(null)}
                    sx={{
                      marginRight: "3rem",
                      cursor: "pointer",
                      color: "red",
                      textDecoration: "none",
                      whiteSpace: "nowrap",
                      padding: "4px 12px",
                      borderRadius: "20px",
                      background: hoveredIndex === index ? "rgba(255,0,0,0.1)" : "transparent",
                      transition: "all 0.3s ease",
                      border: hoveredIndex === index ? "1px solid rgba(255,0,0,0.3)" : "1px solid transparent",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 1,
                      transform: hoveredIndex === index ? "scale(1.05)" : "scale(1)",
                      boxShadow: hoveredIndex === index ? "0 4px 12px rgba(255,0,0,0.1)" : "none",
                    }}
                    title={item.subject}
                  >
                    <Box
                      sx={{
                        width: 6,
                        height: 6,
                        borderRadius: '50%',
                        bgcolor: 'red',
                        animation: 'pulse 2s infinite',
                      }}
                    />
                    {item.subject}
                  </Box>
                ))}
              </Marquee>
            )}
          </Box>

          {/* Right Red Button */}
          <Fade in={!loading} timeout={800}>
            <Button
              variant="contained"
              endIcon={<OpenInNewIcon />}
              sx={{
                height: "100%",
                minWidth: { xs: "100px", sm: "120px", md: "140px" },
                borderRadius: 0,
                fontWeight: "bold",
                fontSize: { xs: "0.7rem", sm: "0.8rem", md: "0.9rem" },
                textTransform: "none",
                flex: "none",
                bgcolor: "red",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                overflow: "hidden",
                '&:hover': { 
                  bgcolor: "#cc0000",
                  transform: "scale(1.02)",
                },
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: '-100%',
                  width: '100%',
                  height: '100%',
                  background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
                  transition: 'left 0.5s ease',
                },
                '&:hover::before': {
                  left: '100%',
                }
              }}
              onClick={() => setModalOpen(true)}
            >
              {t("readMore")}
            </Button>
          </Fade>
        </Box>
      </Slide>

      {/* Modal - REST OF MODAL CODE REMAINS SAME */}
      <Modal 
        open={modalOpen} 
        onClose={() => setModalOpen(false)}
        closeAfterTransition
      >
        <Fade in={modalOpen} timeout={400}>
          <Box sx={modalStyle}>
            {/* Modal Header */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                position: "relative",
                mb: 3,
                bgcolor: "primary.main",
                borderRadius: 3,
                py: 2,
                px: 3,
                boxShadow: "0 2px 12px 0 rgba(60,60,120,0.10)",
                color: "#fff",
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <NewspaperIcon sx={{ fontSize: '1.5rem' }} />
                <Typography
                  variant="h6"
                  component="h2"
                  sx={{
                    fontSize: { xs: "1.1rem", sm: "1.3rem" },
                    fontWeight: "bold",
                  }}
                >
                  {t("allNewsNotifications")}
                </Typography>
              </Box>
              <IconButton
                onClick={() => setModalOpen(false)}
                aria-label={t("closeModal")}
                sx={{
                  color: "#fff",
                  background: "rgba(0,0,0,0.10)",
                  transition: "all 0.3s ease",
                  '&:hover': { 
                    background: "rgba(0,0,0,0.18)",
                    transform: "scale(1.1)",
                  },
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>

            {/* News List */}
            <Box sx={{ maxHeight: '60vh', overflowY: 'auto', pr: 1 }}>
              {news?.length === 0 ? (
                <Box sx={{ textAlign: 'center', py: 4 }}>
                  <TrendingUpIcon sx={{ fontSize: 48, color: 'text.secondary', mb: 2, opacity: 0.5 }} />
                  <Typography sx={{ fontSize: { xs: "0.9rem", sm: "1rem" }, color: 'text.secondary' }}>
                    {t("noNewsAvailable")}
                  </Typography>
                </Box>
              ) : (
                news.map((item, index) => (
                  <Grow in={true} timeout={500 + (index * 100)} key={index}>
                    <Box
                      sx={{
                        mb: 2,
                        p: 2,
                        borderBottom: "1px solid #ddd",
                        cursor: "pointer",
                        borderRadius: 2,
                        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                        position: "relative",
                        overflow: "hidden",
                        '&:hover': { 
                          bgcolor: "#e3f2fd",
                          transform: "translateY(-2px)",
                          boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
                        },
                        '&::before': {
                          content: '""',
                          position: 'absolute',
                          left: 0,
                          top: 0,
                          height: '100%',
                          width: '4px',
                          bgcolor: 'red',
                          opacity: 0,
                          transition: 'opacity 0.3s ease',
                        },
                        '&:hover::before': {
                          opacity: 1,
                        }
                      }}
                      onClick={() => window.open(item.link, "_blank")}
                      onMouseEnter={() => setHoveredIndex(index)}
                      onMouseLeave={() => setHoveredIndex(null)}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                        <Box
                          sx={{
                            width: 8,
                            height: 8,
                            borderRadius: '50%',
                            bgcolor: 'red',
                            mt: 1,
                            flexShrink: 0,
                            animation: 'pulse 2s infinite',
                          }}
                        />
                        <Box sx={{ flex: 1 }}>
                          <Typography
                            variant="subtitle1"
                            fontWeight="bold"
                            sx={{ 
                              fontSize: { xs: "0.9rem", sm: "1.1rem" },
                              color: hoveredIndex === index ? "red" : "text.primary",
                              transition: 'color 0.3s ease',
                              mb: 0.5,
                            }}
                          >
                            {item.subject}
                          </Typography>
                          {item.description && (
                            <Typography
                              variant="body2"
                              color="textSecondary"
                              sx={{ 
                                fontSize: { xs: "0.75rem", sm: "0.85rem" },
                                lineHeight: 1.4,
                              }}
                            >
                              {item.description}
                            </Typography>
                          )}
                        </Box>
                        <OpenInNewIcon 
                          sx={{ 
                            fontSize: '1rem', 
                            color: 'red',
                            opacity: hoveredIndex === index ? 1 : 0,
                            transition: 'all 0.3s ease',
                            transform: hoveredIndex === index ? 'translateX(0)' : 'translateX(-10px)',
                          }} 
                        />
                      </Box>
                    </Box>
                  </Grow>
                ))
              )}
            </Box>
          </Box>
        </Fade>
      </Modal>

      {/* Global styles for animations */}
      <style jsx global>{`
        @keyframes pulse {
         0%, 100% { opacity: 1; transform: scale(1); }
         50% { opacity: 0.7; transform: scale(1.1); }
        }
      `}</style>

      {/* Snackbar */}
      <SnackBarComponent
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
    </>
  );
};
